import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import MeasureWeightComponent from '../components/measure-weight.component';
import { measureWeights } from '../../../../../../redux/measure-weights/action';
import { selectMeasureWeightsQueryItems } from '../../../../../../redux/measure-weights/selector';

const ManagementMeasureWeight = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const measureWeightsQuery = useSelector(selectMeasureWeightsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectMeasureWeights,
    setSelectMeasureWeights
  ] = useState<any>([])

  const fetchDeliveryDatesQueryById = () => {
    dispatch(measureWeights.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/query`, entity: 'measureWeights', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectMeasureWeights({ ...selectMeasureWeights, [field]: event })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchDeliveryDatesQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }


    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectMeasureWeights(measureWeightsQuery?.result?.items)
      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(measureWeights.resetAction({ actionType: 'update' }))
      await dispatch(measureWeights.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights`, entity: 'measureWeights', jsonData: {

          Records: [
            selectMeasureWeights
          ]

        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(measureWeights.resetAction({ actionType: 'create' }))
      await dispatch(measureWeights.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights`, entity: 'measureWeights', jsonData: {

          Records: [
            selectMeasureWeights
          ]

        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/configuration/shipment/measures')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <MeasureWeightComponent
          handleInnerFormChange={handleInnerbasicFormChange}
          selectMeasureWeights={selectMeasureWeights}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementMeasureWeight;